import { render, staticRenderFns } from "./ViewProduct.vue?vue&type=template&id=24f4805c&lang=html&"
import script from "./ViewProduct.vue?vue&type=script&lang=js&"
export * from "./ViewProduct.vue?vue&type=script&lang=js&"
import style0 from "./ViewProduct.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports